let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("05auF")).then(() => parcelRequire('3fBNA'));